import { useTranslation } from 'react-i18next';

function OrganisationApiPage() {
  const { t } = useTranslation();
  return <h1>{t('pages.organisation_api.title')}</h1>;
}

export default OrganisationApiPage;
